import React, { useEffect, useState } from "react";
import style from "./comparePhotos.module.scss";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { DropBox } from "./dropBox";
import { RenderComparison } from "./renderComparison";
import constant from "../../../../constants/constants.json";

export const ComparePhotos = ({ setComparePhotos }) => {
  const selectedPhotosToCompare = useSelector((state) => state.patient.selectedPhotosToCompare);

  const [leftPhoto, setLeftPhoto] = useState(null);
  const [rightPhoto, setRightPhoto] = useState(null);
  const [activeSelection, setActiveSelection] = useState(null);

  useEffect(() => {
    if (selectedPhotosToCompare?.length > 0) {
      const left = selectedPhotosToCompare[0] ? { src: selectedPhotosToCompare[0], label: "Photo 1" } : null;
      const right = selectedPhotosToCompare[1] ? { src: selectedPhotosToCompare[1], label: "Photo 2" } : null;

      setLeftPhoto(left);
      setRightPhoto(right);
      setActiveSelection(null);
    }
  }, [selectedPhotosToCompare]);

  const handleSidebarClick = (image, index) => {
    const photoLabel = `Photo ${index + 1}`;

    if ((leftPhoto && leftPhoto.src === image) || (rightPhoto && rightPhoto.src === image)) {
      toast.warn(constant.photos.compareSameError);
      return;
    }

    if (!leftPhoto) {
      setLeftPhoto({ src: image, label: photoLabel });
      setActiveSelection(image);
    } else if (!rightPhoto) {
      setRightPhoto({ src: image, label: photoLabel });
      setActiveSelection(null);
    } else {
      setLeftPhoto({ src: image, label: photoLabel });
      setRightPhoto(null);
      setActiveSelection(image);
    }
  };

  const handleDragStart = (e, image, index) => {
    e.dataTransfer.setData("imageSrc", image);
    e.dataTransfer.setData("imageLabel", `Photo ${index + 1}`);
  };

  const handleDrop = (e, side) => {
    e.preventDefault();
    const imageSrc = e.dataTransfer.getData("imageSrc");
    const imageLabel = e.dataTransfer.getData("imageLabel");

    if (!imageSrc) return;

    if (side === "left") {
      if (rightPhoto?.src === imageSrc) {
        toast.warn(constant.photos.compareSameError);
        return;
      }
      setLeftPhoto({ src: imageSrc, label: imageLabel });
    } else if (side === "right") {
      if (leftPhoto?.src === imageSrc) {
        toast.warn(constant.photos.compareSameError);
        return;
      }
      setRightPhoto({ src: imageSrc, label: imageLabel });
    }
  };

  const resetComparison = () => {
    setLeftPhoto(null);
    setRightPhoto(null);
    setActiveSelection(null);
  };

  return (
    <div className="d-flex flex-column w-100" style={{ minHeight: "100vh", overflowY: "auto" }}>
      <div className="d-flex justify-content-end">
        <button onClick={() => setComparePhotos(false)} className={`mx-2 mb-2 ${style.icon_btns}`} aria-label="Zoom Photos" title="Zoom Photos">
          <i className="fa fa-exchange" aria-hidden="true"></i>
        </button>
      </div>

      <div className="d-flex flex-grow-1 overflow-hidden">
        <div className={`p-2 ${style.sidebar_scroll}`} style={{ width: "18%" }}>
          {selectedPhotosToCompare?.map((img, index) => (
            <div
              key={img || index}
              className={`card ${style.image_card} ${
                activeSelection === img || leftPhoto?.src === img || rightPhoto?.src === img ? style.selected : ""
              }`}
              draggable
              onDragStart={(e) => handleDragStart(e, img, index)}
              onClick={() => handleSidebarClick(img, index)}
            >
              <div className={style.img_wrapper}>
                <img loading="lazy" src={img} alt={`image-${index}`} />
              </div>
              <div className={style.card_body}>{`Photo ${index + 1}`}</div>
            </div>
          ))}
        </div>

        <div className="flex-grow-1 p-3">
          <div className="d-flex justify-content-between mb-3 px-5">
            <DropBox side="left" photo={leftPhoto} onRemove={() => setLeftPhoto(null)} handleDrop={handleDrop} />
            <DropBox side="right" photo={rightPhoto} onRemove={() => setRightPhoto(null)} handleDrop={handleDrop} />
          </div>

          <RenderComparison leftPhoto={leftPhoto} rightPhoto={rightPhoto} resetComparison={resetComparison} />
        </div>
      </div>
    </div>
  );
};
